import { PropsWithChildren, useContext, useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router';

import { DataContext } from '@utils/useData';

const Page = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const { loaded } = useContext(DataContext);

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);

  return loaded ? (
    <main className="flex flex-col grow w-full mx-auto p-4 tablet:p-8 pb-8 tablet:pb-12">
      <Helmet>
        <link
          rel="canonical"
          href={`https://marcmalignan.com${location.pathname}`}
        />
      </Helmet>
      {children}
    </main>
  ) : null;
};

export default Page;
